import { getQueryClient } from '@/providers/queryClient';
import { getSessionValues } from '@/providers/session-provider/get-session-values';
import { BASE_BACKEND_URL } from '@/requests/constants';
import {
  createAndSetClient,
  createApiQuery,
  mergeHeaders,
  NetworkError,
} from '@pigello/construct-api';
import { getAuthHeaders } from './get-auth-headers';

export const { api, client } = createAndSetClient({
  config: {
    getOrganizationId: () => getSessionValues().organizationId,
  },
  defaults: {
    onRequest: (ctx) => {
      ctx.options.baseURL = BASE_BACKEND_URL;
      const session = getSessionValues();
      const authHeaders = getAuthHeaders({ session });
      ctx.options.headers = mergeHeaders(authHeaders, ctx.options.headers);
    },
    onResponseError: (ctx) => {
      throw new NetworkError({
        message: ctx.response.statusText,
        status: ctx.response.status,
        url: ctx.response.url,
        details: ctx.response._data,
      });
    },
  },
});

export const {
  query,
  useApiQuery,
  useInfiniteApiQuery,
  fetchApiQuery,
  defineInclude,
} = createApiQuery({
  api,
  getQueryClient,
});
